import { useParams } from 'react-router-dom';

import { AppIosBuildPage } from '~/components/pages/AppIosBuildPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppIosBuildRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId} wide>
      <AppIosBuildPage appId={appId} />
    </DashboardTemplate>
  );
};
